import { ReactElement, useState } from 'react';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';

import { uuid } from '../utilities/uuid';
import { KmxMoreVerticalStroked } from '@kmx/mui-icons';
import { ITrackingPayload } from '../types/analytics';
import { ANALYTICS_CONSTANTS, trackEDDL } from '../utilities/analytics';

export interface IKebabMenuItem {
    href: string;
    text: string;
    icon: ReactElement;
    handleClick: (event: React.MouseEvent<HTMLLIElement>) => void;
}

interface IKebabMenuProps {
    children: JSX.Element[];
    category?: string;
}

const KebabMenu = ({ children, category }: IKebabMenuProps) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [menuId, setMenuId] = useState(`kebab-menu-${uuid()}`);
    const isOpen = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
        const payload: ITrackingPayload = {
            event: ANALYTICS_CONSTANTS.EVENTS.CLICK.CTA,
            linkDetails: {
                name: 'three dots',
                position: `Searched:${category}`,
            },
        };
        trackEDDL(payload);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <Box>
            <IconButton
                id={`${menuId}--button`}
                aria-controls={isOpen ? menuId : undefined}
                aria-haspopup="true"
                aria-expanded={isOpen ? 'true' : undefined}
                onClick={handleClick}
                variant="outlined"
                sx={{
                    backgroundColor: '#fff',
                    '&:hover': {
                        backgroundColor: '#fff',
                    },
                }}
            >
                <KmxMoreVerticalStroked fontSize="small" />
            </IconButton>
            <Menu
                id={menuId}
                anchorEl={anchorEl}
                open={isOpen}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': `${menuId}--button`,
                }}
                elevation={3}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                {children}
            </Menu>
        </Box>
    );
};

export default KebabMenu;
